export default __webpack_public_path__ + "static/media/W_D_False.8eed02ae.jpg";